import { mutator } from 'satcheljs';
import { getStore } from '../store/store';
import { initCompositePickerStore, removeCompositePickerStore } from '../actions/privateActions';

mutator(initCompositePickerStore, actionMessage => {
    const store = getStore();
    const viewStateId = actionMessage.viewStateId;
    if (!store.viewStates.has(viewStateId)) {
        store.viewStates.set(viewStateId, {
            options: [],
            filteredOptions: [],
            selectedOption: null,
            textFieldValue: '',
            navIndex: 0,
        });
    }
});

mutator(removeCompositePickerStore, actionMessage => {
    const store = getStore();
    const viewStateId = actionMessage.viewStateId;
    if (store.viewStates.has(viewStateId)) {
        store.viewStates.delete(viewStateId);
    }
});
